<template>
  <Drag horizontalLock :initPosition="{}" :moverange="{
    top: 0.3,
    bottom: 0.8
  }" @handleDragClick="handleClick">
    <div v-if="imgUrl" class="float-window" :class="[position]" :style="customStyle">

      <!-- 图片内容 -->
      <div class="float-content has-breath-effect">
        <img :src="imgUrl" class="float-img" :style="imageStyle">
      </div>

      <!-- 按钮 -->
      <button v-if="showButton" class="breath-btn" :style="buttonStyle"></button>

      <!-- 关闭按钮 -->
      <div v-if="showClose" class="close" @click.stop="handleClose">
        <img src="https://qncweb-back1.ktvsky.com/20220216/vadd/2bc4e987a6af5ad345ab395dfdf6b8d9.png">
      </div>
    </div>
  </Drag>
</template>

<script>
import { mapState } from 'vuex'
import { isIOS } from '@/libs/interfaces'
import Drag from '@/components/common/drag/drag'

const IOS_APP_URL = 'https://apps.apple.com/us/app/%E6%AC%A2%E4%B9%90%E6%AD%8C%E6%88%BF/id6748891695' // 欢乐歌房 iOS App Store
const YYB_APP_URL = 'https://sj.qq.com/appdetail/com.thunder.tv?&from_wxz=1' // 应用宝
const CLICK_CONFIRM_IMG_URL = 'https://qncweb.ktvsky.com/20260318/vadd/d59adcfc24cc0d269375c13acdcd4c58.png'

export default {
  name: 'FloatWindow',

  components: {
    Drag
  },

  props: {
    // 图片URL
    imgUrl: {
      type: String,
      required: true
    },
    // 来源标识
    from: {
      type: String,
      default: ''
    },
    // 浮窗名称(用于埋点)
    name: {
      type: String,
      default: ''
    },
    // 是否显示按钮
    showButton: {
      type: Boolean,
      default: false
    },
    // 是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: false
    },
    // 位置 right/left
    position: {
      type: String,
      default: 'right'
    },
    // 自定义样式
    customStyle: {
      type: Object,
      default: () => ({})
    },
    // 图片样式
    imageStyle: {
      type: Object,
      default: () => ({})
    },
    // 按钮样式
    buttonStyle: {
      type: Object,
      default: () => ({})
    },
    // 点击跳转路径
    jumpPath: {
      type: String,
      default: ''
    },
    // 是否跳转应用商店（为 true 时点击直接跳外链，打点使用 clickAction）
    jumpToAppStore: {
      type: Boolean,
      default: false
    },
    // 点击埋点的 action（jumpToAppStore 时用于「欢乐歌房入口点击」事件）
    clickAction: {
      type: String,
      default: ''
    },
    // 是否禁用“先弹确认图”的中间弹窗（true 时点击浮窗直接执行跳转逻辑）
    disableConfirmPopup: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState({
      is_bind: (state) => state.bind_status,
      bless_path: (state) => state.bless_path,
      photoPag: (state) => state.photoPag,
    })
  },

  mounted() {
    // 展示埋点
    this.$sendLog({
      event_type: 'show',
      event_name: '浮窗广告-展示',
      event_data: {
        name: this.name,
      }
    })
  },

  methods: {
    handleClick() {
      if (this.disableConfirmPopup) {
        this.handleClickInner();
        return;
      }
      // 第一步：先弹出图片弹窗；点击弹窗图片才执行原逻辑
      this.$RaiseMessage.alert(CLICK_CONFIRM_IMG_URL, '', {
        callback: () => {
          this.$sendLog({
            event_type: 'click',
            event_name: '欢乐歌房弹窗点击',
            event_data: {
              action: this.clickAction || this.name,
            },
          });
          this.handleClickInner();
        }
      })
    },

    handleClickInner() {
      // 跳转应用商店：使用统一标识，打点 action 由父组件传入
      if (this.jumpToAppStore) {
        this.$sendLog({
          event_type: 'click',
          event_name: '欢乐歌房入口点击',
          event_data: {
            action: this.clickAction || this.name,
          },
        });
        if (isIOS()) {
          // iOS 先跳 App Store，若未成功（仍在当前页）则降级跳应用宝
          window.location.href = IOS_APP_URL;
          setTimeout(() => {
            if (!document.hidden) {
              window.location.href = YYB_APP_URL;
            }
          }, 2500);
        } else {
          window.location.href = YYB_APP_URL;
        }
        return;
      }
      // 点击埋点
      this.$sendLog({
        event_type: 'click',
        event_name: '浮窗广告-点击',
        event_data: {
          name: this.name,
        }
      })

      // 未绑定房台处理
      if (!this.is_bind) {
        this.$store.commit('SAVE_SHOW_SCODE_BOX', true)
        return
      }

      // 跳转处理
      if (this.jumpPath) {
        this.$router.push({
          path: this.jumpPath,
          query: { fromType: this.from }
        })
      } else if (this.bless_path.includes('blessv1')) {
        this.$router.push('/thunder/interact')
      } else {
        // 国庆改暖冬主题
        this.$photoToastNew({
          fromType: 'photoT_homeFloat',
          backgroundImg: 'https://qncweb.ktvsky.com/20251126/vadd/bcc5811565d20172cf886f32e7e163dd.png',
          showScrollMessages: true,
          showCountdownBtn: true,
          customTagText: '仅￥0.41/小时',
          bottomText: '9.9元/24小时,所有上屏均可免费玩儿',
          isBigPhotoToast: true,
          isGuoQing: true,
          customButtonBg: 'https://qncweb.ktvsky.com/20250925/vadd/07319f8926966c5fdae6901b7d330544.png',
          btnTextColor: '#fff',
          customUploadBg: {
            background: 'url("https://qncweb.ktvsky.com/20250925/vadd/99b1a397870e7c019d066ec1b91d0179.png") no-repeat center center',
            backgroundSize: '38.667vw 38.667vw'
          }
        });
      }
    },

    handleClose() {
      this.$emit('close');
    },
  },
}
</script>

<style lang="scss" scoped>
@keyframes border-expand {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1.15);
    opacity: 0;
  }
}

.float-window {
  position: fixed;
  z-index: 999;
  display: flex;
  align-items: center;
  flex-direction: column;

  // 国庆主题
  width: 120px;
  height: 120px;
  bottom: 700px;

  &.right {
    right: 28px;
  }

  &.left {
    left: 28px;
  }

  .float-content {
    position: relative;
    width: 100%;
    height: 100%;

    // 国庆主题（暂时去掉边框）
  }

  .float-img {
    width: 100%;
    height: auto;
    pointer-events: none;
    border-radius: 20px;
  }

  .close {
    position: absolute;
    top: -10px;
    right: -10px;
    width: 40px;
    height: 40px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .breath-btn {
    margin-top: -50px;
    width: 123px;
    height: 31px;
    background: url('https://qncweb.ktvsky.com/20250113/vadd/3bd020e3367674a2b7954f01dd0274e5.png') no-repeat center center;
    background-size: contain;
    animation: breath 1.5s ease-in-out infinite;
  }
}

@keyframes breath {
  0% {
    transform: scale(1);
  }

  14% {
    transform: scale(1.2);
  }

  28% {
    transform: scale(1);
  }

  42% {
    transform: scale(1.2);
  }

  70% {
    transform: scale(1);
  }
}
</style>
